import React from "react";
import { Location } from "../Location";
import { BookingProfile } from "@bookings/BookingProfile/BookingProfile";

interface Params {
  bookingId: string;
  tab?: string;
}

export class BookingProfileLocation extends Location<Params> {
  constructor(bookingId: string, tab?: string) {
    super({ bookingId, tab });
  }

  render() {
    const { bookingId, tab } = this.params;
    return <BookingProfile id={bookingId} selectedTab={tab || "finance"} />;
  }

  toURI() {
    const { bookingId, tab } = this.params;
    return `/bookings/${bookingId || "new"}/${tab || "finance"}`;
  }
}
